import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function BlogPost4() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="relative pt-32 pb-12 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <Link to="/blog" className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 mb-6 transition-colors">
              <i className="ri-arrow-left-line"></i>
              <span className="font-medium">Blog'a Dön</span>
            </Link>
            
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-500/10 border border-teal-500/20 rounded-full mb-6">
              <span className="text-sm font-medium text-teal-400">Fiber Optik</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Fabrikalarda Fiber Altyapı Kurulumu: Kapsamlı Rehber
            </h1>
            
            <div className="flex flex-wrap items-center gap-4 text-slate-300">
              <div className="flex items-center gap-4 text-sm">
                <div className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  <span>8 Mayıs 2024</span>
                </div>
                <div className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  <span>10 dakika okuma</span>
                </div>
                <div className="flex items-center gap-1">
                  <i className="ri-folder-line"></i>
                  <span>Fiber Optik</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="py-12 bg-slate-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/ae16362e1cbbb8e24bac085b7d8a7ffc.jpg"
                alt="Fabrika Fiber Altyapı Kurulumu"
                className="w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              
              <p className="text-xl text-slate-700 leading-relaxed mb-8 font-medium">
                Sanayi 4.0 çağında fabrika ve endüstriyel tesislerde fiber optik altyapı, üretim süreçlerinin dijital omurgasıdır. Gebze, Tuzla, Kocaeli, Bursa gibi organize sanayi bölgelerindeki fabrikalarda yüksek hızlı, güvenilir ve kesintisiz veri iletişimi için profesyonel fiber optik altyapı kurulumu şarttır.
              </p>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Fabrikalarda Fiber Optik Altyapı Neden Gereklidir?</h2>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Modern fabrikalar, karmaşık otomasyon sistemleri, gerçek zamanlı veri analizi ve bulut tabanlı üretim yönetimi ile çalışmaktadır. Bu sistemlerin sorunsuz çalışması için:
              </p>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-full flex items-center justify-center mb-4">
                    <i className="ri-speed-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Yüksek Hız</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Fiber optik 10 Gbps - 100 Gbps hızlara ulaşabilir. Büyük veri transferi, video izleme ve gerçek zamanlı kontrol için idealdir.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-full flex items-center justify-center mb-4">
                    <i className="ri-shield-check-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Elektromanyetik Bağışıklık</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Fabrika ortamındaki yüksek voltaj, motorlar ve elektromanyetik gürültüden etkilenmez. Bakır kabloya göre çok daha güvenilirdir.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-full flex items-center justify-center mb-4">
                    <i className="ri-route-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Uzun Mesafe</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Single mode fiber ile 10-40 km mesafelere sinyal kaybı olmadan veri iletilebilir. Geniş fabrika kampüsleri için mükemmeldir.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-full flex items-center justify-center mb-4">
                    <i className="ri-shield-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Güvenlik</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Fiber optik dinlenemez ve elektrik iletmez. Patlayıcı ortamlarda güvenle kullanılabilir. Veri güvenliği maksimum seviyededir.
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Fabrika Fiber Altyapı Planlama Aşamaları</h2>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">1. İhtiyaç Analizi ve Keşif</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Fiber altyapı projesinin ilk adımı, fabrika ihtiyaçlarının detaylı analizi ve yerinde keşiftir:
              </p>

              <div className="bg-slate-50 p-6 rounded-xl mb-8 border border-slate-200">
                <ul className="space-y-3 text-slate-700">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Mevcut Durum Tespiti:</strong> Var olan network altyapısı, aktif ekipmanlar ve kablo güzergahları incelenir</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Bant Genişliği İhtiyacı:</strong> Üretim sistemleri, kamera sayısı, kullanıcı sayısı ve veri trafiği hesaplanır</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Bina Yapısı:</strong> Fabrika binası, üretim alanları, ofisler ve depo bölümleri haritalanır</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Çevresel Faktörler:</strong> Sıcaklık, nem, toz, kimyasal maruz kalma ve elektromanyetik gürültü değerlendirilir</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Gelecek Planları:</strong> Kapasite artışı, yeni üretim hatları ve genişleme planları dikkate alınır</span>
                  </li>
                </ul>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">2. Sistem Tasarımı ve Proje Hazırlığı</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                İhtiyaç analizi sonrasında detaylı sistem tasarımı yapılır:
              </p>

              <div className="space-y-6 mb-8">
                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl">
                  <h4 className="font-bold text-slate-900 mb-3 flex items-center gap-2">
                    <i className="ri-route-line text-teal-500 text-xl"></i>
                    Topoloji Seçimi
                  </h4>
                  <p className="text-slate-700 text-sm leading-relaxed mb-3">
                    <strong>Star (Yıldız) Topoloji:</strong> Merkezi bir switch'ten tüm noktalara fiber çekilir. En yaygın ve güvenilir yöntemdir.<br />
                    <strong>Ring (Halka) Topoloji:</strong> Yedeklilik gerektiren kritik uygulamalar için. Bir hat kesilse bile sistem çalışmaya devam eder.<br />
                    <strong>Mesh (Ağ) Topoloji:</strong> Çok yüksek güvenilirlik gerektiren uygulamalar için. Her nokta birden fazla yolla bağlanır.
                  </p>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl">
                  <h4 className="font-bold text-slate-900 mb-3 flex items-center gap-2">
                    <i className="ri-settings-line text-teal-500 text-xl"></i>
                    Fiber Tipi Seçimi
                  </h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    <strong>Single Mode (9/125 µm):</strong> Uzun mesafeler (2+ km), yüksek hız, bina arası bağlantılar için<br />
                    <strong>Multi Mode OM3 (50/125 µm):</strong> Orta mesafeler (300 m), 10 Gbps, bina içi omurga için<br />
                    <strong>Multi Mode OM4 (50/125 µm):</strong> Orta mesafeler (550 m), 10 Gbps, yüksek performans için<br />
                    <strong>Fiber Sayısı:</strong> Mevcut ihtiyaç + %30-50 yedek kapasite
                  </p>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl">
                  <h4 className="font-bold text-slate-900 mb-3 flex items-center gap-2">
                    <i className="ri-shield-line text-teal-500 text-xl"></i>
                    Kablo Tipi Seçimi
                  </h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    <strong>Indoor (İç Mekan):</strong> LSZH kılıflı, yangın güvenliği yüksek<br />
                    <strong>Outdoor (Dış Mekan):</strong> UV dayanımlı, su geçirmez, çift kılıflı<br />
                    <strong>Armored (Zırhlı):</strong> Kemirgen korumalı, mekanik dayanım yüksek<br />
                    <strong>Aerial (Havai):</strong> Direkler arası geçişler için taşıyıcı telli
                  </p>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">3. Kablo Güzergahı Belirleme</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Fiber kablo güzergahı belirlenirken dikkat edilmesi gerekenler:
              </p>

              <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-r-xl mb-8">
                <h4 className="font-bold text-amber-900 mb-3">Güzergah Planlama Kriterleri:</h4>
                <ul className="space-y-2 text-amber-800 text-sm">
                  <li className="flex items-start gap-2">
                    <span>•</span>
                    <span>Yüksek voltaj hatlarından minimum 30 cm uzakta olmalı</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span>•</span>
                    <span>Sıcak yüzeyler, buhar boruları ve kimyasal hatlardan uzak tutulmalı</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span>•</span>
                    <span>Fiber bükülme yarıçapı minimum 10x kablo çapı olmalı (genellikle 30-50 mm)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span>•</span>
                    <span>Mekanik hasar riski olan bölgelerden kaçınılmalı</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span>•</span>
                    <span>Gelecekte erişim ve bakım kolaylığı sağlanmalı</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span>•</span>
                    <span>Kablo kanalları ve tray sistemleri uygun boyutlandırılmalı</span>
                  </li>
                </ul>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Kurulum Aşaması</h2>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">1. Altyapı Hazırlığı</h3>
              
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <h4 className="font-bold text-slate-900 mb-3">Kablo Kanalları</h4>
                  <ul className="space-y-2 text-slate-700 text-sm">
                    <li className="flex items-start gap-2">
                      <span>•</span>
                      <span>Metal kablo kanalları (tray, ladder, basket)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span>•</span>
                      <span>PVC veya metal boru sistemleri</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span>•</span>
                      <span>Zemin altı kanallar ve menhol sistemleri</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span>•</span>
                      <span>Tavan üstü ve duvar montaj sistemleri</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <h4 className="font-bold text-slate-900 mb-3">Rack ve Kabin Kurulumu</h4>
                  <ul className="space-y-2 text-slate-700 text-sm">
                    <li className="flex items-start gap-2">
                      <span>•</span>
                      <span>19" standart network rack'leri</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span>•</span>
                      <span>Fiber patch panel ve splice tray'ler</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span>•</span>
                      <span>Kablo yönetim sistemleri</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span>•</span>
                      <span>Soğutma ve havalandırma sistemleri</span>
                    </li>
                  </ul>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">2. Fiber Kablo Döşeme</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Kablo döşeme işlemi profesyonel ekip ve ekipman gerektirir:
              </p>

              <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-8 rounded-2xl mb-8 border border-teal-100">
                <h4 className="text-xl font-bold text-slate-900 mb-4">Döşeme Adımları:</h4>
                <ol className="space-y-4 text-slate-700">
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">1</span>
                    <div>
                      <strong className="block mb-1">Kablo Makarası Yerleştirme</strong>
                      <span>Kablo makarası uygun yere yerleştirilir ve dönme mekanizması kurulur</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">2</span>
                    <div>
                      <strong className="block mb-1">Çekme İpi Geçirme</strong>
                      <span>Kablo kanallarından çekme ipi geçirilir (fish tape veya blower ile)</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">3</span>
                    <div>
                      <strong className="block mb-1">Kablo Çekme</strong>
                      <span>Fiber kablo yavaşça ve kontrollü şekilde çekilir. Maksimum çekme kuvveti aşılmamalı (tipik 600 N)</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">4</span>
                    <div>
                      <strong className="block mb-1">Sabitleme</strong>
                      <span>Kablo uygun aralıklarla (1-1.5 m) kablo bağları ile sabitlenir</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-teal-500 text-white rounded-full flex items-center justify-center font-bold text-sm">5</span>
                    <div>
                      <strong className="block mb-1">Etiketleme</strong>
                      <span>Her kablo ucu etiketlenir ve dokümante edilir</span>
                    </div>
                  </li>
                </ol>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">3. Sonlandırma ve Ek İşlemleri</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Fiber kablolar patch panel'lere sonlandırılır veya <Link to="/blog/fusion-splicing-nedir" className="text-teal-600 hover:text-teal-700 font-semibold">fusion splicing</Link> ile birleştirilir:
              </p>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-plug-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Konnektör Sonlandırma</h4>
                  <p className="text-slate-700 text-sm leading-relaxed mb-3">
                    SC, LC, ST veya MTP/MPO konnektörler ile sonlandırma. Patch panel'lere montaj ve test.
                  </p>
                  <p className="text-slate-600 text-xs">
                    <strong>Avantaj:</strong> Esnek, değiştirilebilir<br />
                    <strong>Dezavantaj:</strong> Daha yüksek kayıp (0.3-0.5 dB)
                  </p>
                </div>

                <div className="bg-white border-2 border-slate-200 p-6 rounded-xl">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-flashlight-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Fusion Splicing</h4>
                  <p className="text-slate-700 text-sm leading-relaxed mb-3">
                    Kaynaklı ek ile kalıcı bağlantı. Splice tray'lere yerleştirme ve splice closure montajı.
                  </p>
                  <p className="text-slate-600 text-xs">
                    <strong>Avantaj:</strong> Çok düşük kayıp (0.02-0.05 dB)<br />
                    <strong>Dezavantaj:</strong> Kalıcı, değiştirilemez
                  </p>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">4. Test ve Sertifikasyon</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Kurulum tamamlandıktan sonra kapsamlı testler yapılır:
              </p>

              <div className="bg-slate-50 p-6 rounded-xl mb-8 border border-slate-200">
                <ul className="space-y-3 text-slate-700">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Görsel Muayene:</strong> Fiber mikroskop ile konnektör uçları ve ek noktaları kontrol edilir</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Işık Kaybı Testi:</strong> Light source & power meter ile insertion loss ölçülür</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong><Link to="/blog/otdr-testi-nedir" className="text-teal-600 hover:text-teal-700">OTDR Testi</Link>:</strong> Her fiber için detaylı OTDR trace alınır ve raporlanır</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Performans Testi:</strong> Aktif ekipmanlar ile veri iletim hızı ve bant genişliği test edilir</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span><strong>Dokümantasyon:</strong> As-built çizimleri, test raporları ve fiber haritası teslim edilir</span>
                  </li>
                </ul>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Fabrika Fiber Altyapı Uygulama Alanları</h2>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-robot-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Endüstriyel Otomasyon</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    PLC'ler, SCADA sistemleri, robot kontrol üniteleri ve sensör ağları için yüksek hızlı bağlantı. Gerçek zamanlı veri iletişimi.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-camera-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Güvenlik Kamera Sistemleri</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Yüksek çözünürlüklü <Link to="/guvenlik-sistemleri/ip-kamera-sistemleri" className="text-teal-600 hover:text-teal-700 font-semibold">IP kamera sistemleri</Link> için fiber backbone. 4K ve 8K kamera desteği.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-phone-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">VoIP Telefon Sistemleri</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    IP tabanlı santral sistemleri ve dahili telefon ağı. Yüksek ses kalitesi ve güvenilirlik.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-wifi-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Kablosuz Ağ Altyapısı</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Wi-Fi access point'leri için fiber backbone. Geniş alan kapsama ve yüksek kullanıcı kapasitesi.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-server-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Veri Merkezi Bağlantısı</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Fabrika içi sunucu odası veya dış veri merkezine yüksek hızlı bağlantı. Bulut sistemleri entegrasyonu.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-shield-check-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Geçiş Kontrol Sistemleri</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    <Link to="/guvenlik-sistemleri/gecis-kontrol-sistemleri" className="text-teal-600 hover:text-teal-700 font-semibold">Kartlı geçiş</Link>, turnike ve bariyer sistemleri için network altyapısı.
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">OSB'lerde Fiber Altyapı Önemi</h2>

              <p className="text-slate-700 leading-relaxed mb-6">
                <Link to="/bolgeler/gebze" className="text-teal-600 hover:text-teal-700 font-semibold">Gebze OSB</Link>, <Link to="/bolgeler/tuzla" className="text-teal-600 hover:text-teal-700 font-semibold">Tuzla OSB</Link>, <Link to="/bolgeler/kocaeli" className="text-teal-600 hover:text-teal-700 font-semibold">Kocaeli OSB</Link> gibi organize sanayi bölgelerinde fiber optik altyapı:
              </p>

              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-slate-50 rounded-xl border border-teal-100">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className="ri-global-line text-3xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Rekabet Avantajı</h4>
                  <p className="text-slate-600 text-sm">
                    Hızlı internet ve veri iletişimi ile global pazarlarda rekabet gücü artar
                  </p>
                </div>

                <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-slate-50 rounded-xl border border-teal-100">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className="ri-line-chart-line text-3xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Verimlilik Artışı</h4>
                  <p className="text-slate-600 text-sm">
                    Gerçek zamanlı üretim takibi ve veri analizi ile %20-30 verimlilik artışı
                  </p>
                </div>

                <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-slate-50 rounded-xl border border-teal-100">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className="ri-shield-check-line text-3xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Güvenilirlik</h4>
                  <p className="text-slate-600 text-sm">
                    Kesintisiz üretim için %99.9 uptime garantisi
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Sık Sorulan Sorular</h2>

              <div className="space-y-4 mb-12">
                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>Fabrika fiber altyapı kurulumu ne kadar sürer?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Süre fabrika büyüklüğüne ve karmaşıklığına bağlıdır. Orta ölçekli bir fabrika (5000-10000 m²) için 2-4 hafta, büyük tesisler için 1-3 ay sürebilir. Planlama ve tasarım aşaması ayrıca 1-2 hafta alır.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>Mevcut üretimi durdurmadan kurulum yapılabilir mi?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Evet, fiber altyapı kurulumu genellikle üretimi durdurmadan yapılabilir. Çalışmalar vardiya dışı saatlerde, hafta sonları veya üretim molalarında planlanır. Kritik bağlantılar için geçici yedek hatlar kurulabilir.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>Fiber altyapı maliyeti nedir?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Maliyet birçok faktöre bağlıdır: fabrika büyüklüğü, fiber mesafesi, kablo tipi, sonlandırma sayısı ve altyapı karmaşıklığı. Ortalama olarak m² başına 50-150 TL arasında değişir. Ücretsiz keşif hizmetimiz ile detaylı fiyat teklifi sunuyoruz.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>Fiber altyapı bakım gerektirir mi?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Fiber optik altyapı minimal bakım gerektirir. Yılda 1-2 kez periyodik kontrol ve temizlik önerilir. Konnektör uçları temizlenmeli, kablo bağlantıları kontrol edilmeli ve OTDR testi ile performans izlenmelidir. Profesyonel bakım hizmetimiz mevcuttur.
                  </p>
                </details>
              </div>

            </div>

            {/* CTA Section */}
            <div className="mt-16 p-8 bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl text-center">
              <h3 className="text-3xl font-bold text-white mb-4">
                Fabrika Fiber Altyapı Kurulumu
              </h3>
              <p className="text-slate-300 text-lg mb-6">
                Sanayi 4.0 için profesyonel fiber optik çözümler
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <a
                  href="tel:+905537165561"
                  className="px-8 py-4 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-teal-500/50 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line mr-2"></i>
                  +90 553 716 55 61
                </a>
                <a
                  href="https://wa.me/908505551234"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-white hover:bg-slate-50 text-slate-900 font-semibold rounded-xl transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  Ücretsiz Keşif
                </a>
              </div>
            </div>

            {/* İlgili Hizmetler */}
            <div className="mt-12">
              <h3 className="text-2xl font-bold text-slate-900 mb-6">İlgili Hizmetlerimiz</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <Link to="/fiber-hizmetleri/fabrika-fiber" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-building-2-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">Fabrika Fiber Altyapı</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Endüstriyel tesisler için fiber kurulum</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
                <Link to="/fiber-hizmetleri/fiber-sonlandirma" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-flashlight-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">Fusion Splicing & Sonlandırma</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Fiber ek ve konnektör işlemleri</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
                <Link to="/fiber-hizmetleri/otdr-test" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-line-chart-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">OTDR Test Hizmeti</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Kurulum sonrası test ve sertifikasyon</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
                <Link to="/guvenlik-sistemleri/ip-kamera-sistemleri" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-camera-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">IP Kamera Sistemleri</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Fabrika güvenlik kamera çözümleri</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
}